import ApplicationAdapter from 'garaje/adapters/application';

export default class DraftDocumentUploadLinkAdapter extends ApplicationAdapter {
  // `draft-document-upload-link` is a nested create under draft-documents:
  // POST /a/visitors/api/v3/draft-documents/upload-links. `_buildURL` joins the
  // path segments and only percent-encodes the id, so a slashed `pathForType`
  // yields the nested collection URL verbatim. Mirrors `location-export-job` /
  // `notification-configuration`.
  pathForType(): string {
    return 'draft-documents/upload-links';
  }
}
